import { Box } from '@mui/material';
import React from 'react';

import NoticesAlert from '../../../features/notices/components/noticesAlert';
import { useDesktopLayout } from '../../hooks';
import DesktopHeader from './components/desktop-header';
import MainContentArea from './components/main-content-area';
import NotificationPanelDrawer from './components/notification-panel-drawer';
import SidebarDrawer from './components/sidebar-drawer';

export type DesktopLayoutProps = {
  children?: React.ReactNode;
};

/**
 * Desktop Layout Component
 * Main layout component that orchestrates all desktop layout elements
 * Refactored into smaller, manageable components for better maintainability
 */
const DesktopLayout = ({ children }: DesktopLayoutProps) => {
  const { isSidebarOpen, isNotificationPanelOpen, toggleSidebar, toggleNotificationPanel, closeNotificationPanel } =
    useDesktopLayout();

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <NoticesAlert />

      {/* Desktop Header */}
      <DesktopHeader
        isSidebarOpen={isSidebarOpen}
        isNotificationPanelOpen={isNotificationPanelOpen}
        onToggleSidebar={toggleSidebar}
        onToggleNotificationPanel={toggleNotificationPanel}
      />

      {/* Sidebar Drawer */}
      <SidebarDrawer isOpen={isSidebarOpen} onClose={toggleSidebar} />

      {/* Main Content Area */}
      <MainContentArea isSidebarOpen={isSidebarOpen} isNotificationPanelOpen={isNotificationPanelOpen}>
        {children}
      </MainContentArea>

      {/* Notification Panel Drawer */}
      <NotificationPanelDrawer isOpen={isNotificationPanelOpen} onClose={closeNotificationPanel} />
    </Box>
  );
};

export default DesktopLayout;
